import { Button, IconButton } from '@material-ui/core';
import { ExitToApp, Home } from '../icons/MaterialIcons';
import { withStyles } from '@material-ui/styles';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { appBarHeightPx } from '../../constants/styles/app-bar-height';
import { colorDef } from '../../constants/styles/color-def';
import { viewTexts } from '../../constants/view-texts';
import { LogoutDialog } from '../dialogs/logout-dialog';

const vt = viewTexts.appbar;

const Root = styled.div`
  width: 100%;
  height: ${appBarHeightPx}px;
  background-color: ${colorDef.appBar};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const LinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HomeButtonWrapper = styled.div`
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginStateWrapper = styled.div`
  padding-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const HomeWhite = () => <Home style={{ color: 'white' }} />;

const ExitToAppWhite = () => <ExitToApp style={{ color: 'white' }} />;

const UserName = styled.div`
  color: white;
`;

const FontWhiteButton = withStyles(() => ({
  root: {
    color: 'white'
  }
}))(Button);

interface Props {
  username: string;
  loggedIn: boolean | undefined;
  logoutOnClick: () => void;
  dialogOpen: boolean;
  onClose: () => void;
  homeIconOnClick: () => void;
  onKoumutenListClick: () => void;
  userListOnClick: () => void;
  csvListOnClick: () => void;
}

export const AppBarView: FC<Props> = memo(
  ({
    username,
    loggedIn,
    logoutOnClick,
    dialogOpen,
    onClose,
    homeIconOnClick,
    onKoumutenListClick,
    userListOnClick,
    csvListOnClick
  }: Readonly<Props>) => (
    <Root>
      <LinksWrapper>
        {loggedIn === true ? (
          <>
            <HomeButtonWrapper>
              <IconButton onClick={homeIconOnClick}>
                <HomeWhite />
              </IconButton>
            </HomeButtonWrapper>
            <FontWhiteButton color='inherit' onClick={onKoumutenListClick}>
              {vt.koumutenList}
            </FontWhiteButton>
            <FontWhiteButton color='inherit' onClick={userListOnClick}>
              {vt.userList}
            </FontWhiteButton>
            <FontWhiteButton color='inherit' onClick={csvListOnClick}>
              {vt.csvList}
            </FontWhiteButton>
          </>
        ) : (
          undefined
        )}
      </LinksWrapper>
      <LoginStateWrapper>
        {loggedIn === true ? (
          <>
            <UserName>{username}</UserName>
            <div title={vt.logout}>
              <IconButton onClick={logoutOnClick}>
                <ExitToAppWhite />
              </IconButton>
            </div>
          </>
        ) : (
          undefined
        )}
      </LoginStateWrapper>
      <LogoutDialog open={dialogOpen} onClose={onClose} />
    </Root>
  )
);

AppBarView.displayName = 'AppBarView';
